import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ContextMenuPreferenceState {
  enabled: boolean;
}

interface ContextMenuPreferenceActions {
  setEnabled: (enabled: boolean) => void;
}

export type ContextMenuPreferenceStore = ContextMenuPreferenceState & ContextMenuPreferenceActions;

const STORAGE_KEY = 'kc-context-menu-settings';
const STORE_NAME = 'ContextMenuPreferenceStore';

export const useContextMenuPreferenceStore = create<ContextMenuPreferenceStore>()(
  devtools(
    persist(
      set => ({
        enabled: true,

        setEnabled: (enabled: boolean) => {
          set({ enabled }, undefined, `${STORE_NAME}/setEnabled`);
        },
      }),
      {
        name: STORAGE_KEY,
        partialize: state => ({ enabled: state.enabled }),
      },
    ),
    { name: STORE_NAME },
  ),
);
